<div
  class="ddc-read-word-mobile-sheet"
  [ngClass]="{
    'dark-theme': _isDarkTheme,
    'light-theme': _isLightTheme,
    'paper-theme': _isPaperTheme,
  }"
>
  <!-- Header with word title and privacy -->
  <div class="sheet-header sticky-header">
    <div class="header-left">
      @if (word() !== undefined) {
        <ddc-text-gradient
          class="text-xl"
          [_icon]="'fiber_manual_record'"
          [_text]="'Word'"
          [_type]="'1'"
        ></ddc-text-gradient>
      } @else if (pair() !== undefined) {
        <ddc-text-gradient
          class="text-xl"
          [_icon]="'fiber_smart_record'"
          [_text]="'Pair'"
          [_type]="'1'"
        ></ddc-text-gradient>
      } @else if (dictionary() !== undefined) {
        <ddc-text-gradient
          class="text-xl"
          [_icon]="'auto_stories'"
          [_text]="'Dictionary'"
          [_type]="'1'"
        ></ddc-text-gradient>
      } @else if (collection() !== undefined) {
        <ddc-text-gradient
          class="text-xl"
          [_icon]="'collections_bookmark'"
          [_text]="'Collection'"
          [_type]="'1'"
        ></ddc-text-gradient>
      }
    </div>
    @if (word() !== undefined) {
      <div class="header-right" *ngIf="word()?.privacy">
        <ddc-privacy [code]="word()?.privacy" [withText]="false"></ddc-privacy>
      </div>
    }
    @if (pair() !== undefined) {
      <div class="header-right" *ngIf="pair()?.word_1.privacy">
        <ddc-privacy [code]="pair()?.word_1.privacy" [withText]="false"></ddc-privacy>
      </div>
    }
  </div>
  <mat-divider></mat-divider>

  <!-- Content section -->
  <form class="add-mobile-form" [formGroup]="_form">
    <!-- Form Error -->
    @if (_form.errors || _addError) {
      <div class="alert alert-danger">
        <div>{{ _addError }}</div>
        @if (_isSubscriptionError) {
          <div>Please upgrade your subscription to continue.</div>
        }
      </div>
    }

    <!-- Content -->
    <div
      class="add-mobile-form-main-both"
      [ngClass]="{
        'add-mobile-form-main-pair-available': pair() !== undefined,
      }"
    >
      <!-- Word -->
      <div class="add-mobile-form-main" *ngIf="word() !== undefined">
        <!-- Language -->
        <mat-form-field>
          <mat-label><mat-icon>language</mat-icon>&nbsp;&nbsp;Language</mat-label>
          <mat-select
            formControlName="_1_language"
            [(value)]="_selectedLanguage"
            (selectionChange)="onLanguageChange($event)"
          >
            <mat-option *ngFor="let language of languages" [value]="language.raw_value">
              {{ language.view_value }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Article and Word -->
        <mat-form-field>
          <mat-label>Article</mat-label>
          <mat-select formControlName="_1_article" [disabled]="!_selectedLngHasArticle" [(value)]="_selectedArticle">
            <mat-option *ngFor="let article of articles" [value]="article.raw_value">
              {{ article.view_value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Word</mat-label>
          <input formControlName="_1_word" matInput placeholder="Ex. Apple" />
          @if (_form.get('_1_word')?.hasError('maxlength')) {
            <mat-error>Maximum {{ _wordMaxlength }} characters.</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Pos</mat-label>
          <mat-select formControlName="_1_pos" [(value)]="_selectedPos">
            <mat-option *ngFor="let pos of poses" [value]="pos.raw_value">
              {{ pos.view_value }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Definition -->
        <mat-form-field>
          <mat-label><mat-icon>description</mat-icon>&nbsp;&nbsp;Definition</mat-label>
          <textarea
            formControlName="_1_definition"
            matInput
            placeholder="Ex. The round fruit of a tree of the rose family"
          ></textarea>
          @if (_form.get('_1_definition')?.hasError('maxlength')) {
            <mat-error>Maximum {{ _definitionMaxlength }} characters.</mat-error>
          }
        </mat-form-field>

        <!-- Example -->
        <mat-form-field>
          <mat-label><mat-icon>format_quote</mat-icon>&nbsp;&nbsp;Example</mat-label>
          <textarea formControlName="_1_example" matInput placeholder="Ex. I ate an apple"></textarea>
          @if (_form.get('_1_example')?.hasError('maxlength')) {
            <mat-error>Maximum {{ _exampleMaxlength }} characters.</mat-error>
          }
        </mat-form-field>

        <!-- ! Category 1-->
        <div class="add-dialog-cat">
          @if (_loadedCats) {
            <ddc-elem-chooser-one
              [_allElems]="_userCats"
              [_defaultElem]="selectedCategory()[0]"
              [_elemType]="'category'"
              [_label]="'Category'"
              [_labelIcon]="'workspaces'"
              [_placeholder]="'Select a Category'"
              [_type]="'single'"
              (selectedElemsChange)="updateSelectedCat($event)"
            ></ddc-elem-chooser-one>
          }
        </div>
        <!-- ! Tags1 -->
        @if (_loadedTags) {
          <ddc-elem-chooser-one
            [_allElems]="_userTags"
            [_defaultElems]="selectedTags()"
            [_elemType]="'tag'"
            [_label]="'Tags'"
            [_labelIcon]="'sell'"
            [_placeholder]="'Select tags...'"
            [_type]="'multi'"
            (selectedElemsChange)="updateSelectedTags($event)"
          ></ddc-elem-chooser-one>
        }
      </div>
      <!-- Pair Word 1 -->
      <div class="add-mobile-form-main" *ngIf="pair() !== undefined">
        <!-- Language -->
        <mat-form-field>
          <mat-label><mat-icon>language</mat-icon>&nbsp;&nbsp;Language</mat-label>
          <mat-select
            formControlName="_1_language"
            [(value)]="_selectedLanguage"
            (selectionChange)="onLanguageChange($event)"
          >
            <mat-option *ngFor="let language of languages" [value]="language.raw_value">
              {{ language.view_value }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Article and Word -->
        <mat-form-field>
          <mat-label>Article</mat-label>
          <mat-select formControlName="_1_article" [disabled]="!_selectedLngHasArticle" [(value)]="_selectedArticle">
            <mat-option *ngFor="let article of articles" [value]="article.raw_value">
              {{ article.view_value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Word</mat-label>
          <input formControlName="_1_word" matInput placeholder="Ex. Apple" />
          @if (_form.get('_1_word')?.hasError('maxlength')) {
            <mat-error>Maximum {{ _wordMaxlength }} characters.</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>Pos</mat-label>
          <mat-select formControlName="_1_pos" [(value)]="_selectedPos">
            <mat-option *ngFor="let pos of poses" [value]="pos.raw_value">
              {{ pos.view_value }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Definition -->
        <mat-form-field>
          <mat-label><mat-icon>description</mat-icon>&nbsp;&nbsp;Definition</mat-label>
          <textarea
            formControlName="_1_definition"
            matInput
            placeholder="Ex. The round fruit of a tree of the rose family"
          ></textarea>
          @if (_form.get('_1_definition')?.hasError('maxlength')) {
            <mat-error>Maximum {{ _definitionMaxlength }} characters.</mat-error>
          }
        </mat-form-field>

        <!-- Example -->
        <mat-form-field>
          <mat-label><mat-icon>format_quote</mat-icon>&nbsp;&nbsp;Example</mat-label>
          <textarea formControlName="_1_example" matInput placeholder="Ex. I ate an apple"></textarea>
          @if (_form.get('_1_example')?.hasError('maxlength')) {
            <mat-error>Maximum {{ _exampleMaxlength }} characters.</mat-error>
          }
        </mat-form-field>

        <!-- ! Category 1-->
        <div class="add-dialog-cat">
          @if (_loadedCats) {
            <ddc-elem-chooser-one
              [_allElems]="_userCats"
              [_defaultElem]="selectedCategory()[0]"
              [_elemType]="'category'"
              [_label]="'Category'"
              [_labelIcon]="'workspaces'"
              [_placeholder]="'Select a Category'"
              [_type]="'single'"
              (selectedElemsChange)="updateSelectedCat($event)"
            ></ddc-elem-chooser-one>
          }
        </div>
        <!-- ! Tags1 -->
        @if (_loadedTags) {
          <ddc-elem-chooser-one
            [_allElems]="_userTags"
            [_defaultElems]="selectedTags()"
            [_elemType]="'tag'"
            [_label]="'Tags'"
            [_labelIcon]="'sell'"
            [_placeholder]="'Select tags...'"
            [_type]="'multi'"
            (selectedElemsChange)="updateSelectedTags($event)"
          ></ddc-elem-chooser-one>
        }
      </div>
      <!-- Pair Word 2 -->
      <div class="add-mobile-form-main" *ngIf="pair() !== undefined">
        <!-- Language -->
        <mat-form-field>
          <mat-label><mat-icon>language</mat-icon>&nbsp;&nbsp;Language</mat-label>
          <mat-select
            formControlName="_2_language"
            [(value)]="_selectedLanguage2"
            (selectionChange)="onLanguageChange2($event)"
          >
            <mat-option *ngFor="let language of languages2" [value]="language.raw_value">
              {{ language.view_value }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field>
          <mat-label>Article</mat-label>
          <mat-select formControlName="_2_article" [disabled]="!_selectedLngHasArticle2" [(value)]="_selectedArticle2">
            <mat-option *ngFor="let article of articles2" [value]="article.raw_value">
              {{ article.view_value }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Word</mat-label>
          <input formControlName="_2_word" matInput placeholder="Ex. Apple" />
          @if (_form.get('_2_word')?.hasError('maxlength')) {
            <mat-error>Maximum {{ _wordMaxlength }} characters.</mat-error>
          }
        </mat-form-field>

        <mat-form-field>
          <mat-label>POS</mat-label>
          <mat-select formControlName="_2_pos" [(value)]="_selectedPos2">
            <mat-option *ngFor="let pos of poses2" [value]="pos.raw_value">
              {{ pos.view_value }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Definition -->
        <mat-form-field>
          <mat-label><mat-icon>description</mat-icon>&nbsp;&nbsp;Definition</mat-label>
          <textarea
            formControlName="_2_definition"
            matInput
            placeholder="Ex. The round fruit of a tree of the rose family"
          ></textarea>
          @if (_form.get('_2_definition')?.hasError('maxlength')) {
            <mat-error>Maximum {{ _definitionMaxlength }} characters.</mat-error>
          }
        </mat-form-field>

        <!-- Example -->
        <mat-form-field>
          <mat-label><mat-icon>format_quote</mat-icon>&nbsp;&nbsp;Example</mat-label>
          <textarea formControlName="_2_example" matInput placeholder="Ex. I ate an apple"></textarea>
          @if (_form.get('_2_example')?.hasError('maxlength')) {
            <mat-error>Maximum {{ _exampleMaxlength }} characters.</mat-error>
          }
        </mat-form-field>
        <!-- ! Category 2-->
        <div class="add-dialog-cat">
          @if (_loadedCats) {
            <ddc-elem-chooser-one
              [_allElems]="_userCats"
              [_defaultElem]="selectedCategory2()[0]"
              [_elemType]="'category'"
              [_label]="'Category'"
              [_labelIcon]="'workspaces'"
              [_placeholder]="'Select a Category'"
              [_type]="'single'"
              (selectedElemsChange)="updateSelectedCat2($event)"
            ></ddc-elem-chooser-one>
          }
        </div>
        <!-- ! Tags 2-->
        @if (_loadedTags) {
          <ddc-elem-chooser-one
            [_allElems]="_userTags"
            [_defaultElems]="selectedTags2()"
            [_elemType]="'tag'"
            [_label]="'Tags'"
            [_labelIcon]="'sell'"
            [_placeholder]="'Select tags...'"
            [_type]="'multi'"
            (selectedElemsChange)="updateSelectedTags2($event)"
          ></ddc-elem-chooser-one>
        }
      </div>
      <!-- Dictionary -->
      <div class="add-mobile-form-main" *ngIf="dictionary() !== undefined">
        <mat-form-field>
          <mat-label>Title</mat-label>
          <input formControlName="_dictionary_title" matInput placeholder="Ex. German-English-A1" />
        </mat-form-field>

        <!-- Definition -->
        <mat-form-field>
          <mat-label><mat-icon>description</mat-icon>&nbsp;&nbsp;Description</mat-label>
          <textarea
            formControlName="_dictionary_description"
            matInput
            placeholder="Ex. German/English A1 words and phrases"
          ></textarea>
        </mat-form-field>
      </div>
      <!-- Collection -->
      <div class="add-mobile-form-main" *ngIf="collection() !== undefined">
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input formControlName="_collection_name" matInput placeholder="Collection Name" />
        </mat-form-field>
      </div>
    </div>

    <!-- ! W/P Dictionaries -->
    @if (
      _loadedDics &&
      !_hasDic &&
      !_wordCreated &&
      !_pairCreated &&
      dictionary() === undefined &&
      collection() === undefined
    ) {
      <ddc-elem-chooser-one
        [_allElems]="_userDics"
        [_defaultElems]="selectedDics()"
        [_elemType]="'dictionary'"
        [_label]="'Dictionaries'"
        [_labelIcon]="'book'"
        [_placeholder]="'Add to dictionaries...'"
        [_type]="'multi'"
        (selectedElemsChange)="updateSelectedDics($event)"
      ></ddc-elem-chooser-one>
    }
    <!-- Privacy -->
    <mat-chip-listbox
      *ngIf="!_wordCreated && !_pairCreated && dictionary() === undefined && collection() === undefined"
      aria-label="privacy selection"
      formControlName="_privacy"
      [ngClass]="{
        'dark-theme': _isDarkTheme,
        'light-theme': _isLightTheme,
        'paper-theme': _isPaperTheme,
      }"
      [(ngModel)]="_selectedPrivacyChipOptions"
    >
      <mat-chip-option selected [value]="'P01'"><mat-icon matChipAvatar>public</mat-icon>Public</mat-chip-option>
      <mat-chip-option [value]="'P02'"><mat-icon matChipAvatar>group</mat-icon>Followers</mat-chip-option>
      <mat-chip-option [value]="'P03'"><mat-icon matChipAvatar>lock</mat-icon>Only Me</mat-chip-option>
    </mat-chip-listbox>
    <mat-divider></mat-divider>

    <!-- Submit Button -->
    <div class="mobile-buttons">
      <div></div>
      <div class="ddc-mobile-buttons-right">
        <button class="add-dialog-close-btn" mat-button type="button" (click)="closeDialog()">Cancel</button>
        <ddc-button-s-one
          *ngIf="!_wordCreated && !_pairCreated"
          [_isLoading]="EditWordPairDicCommand.isExecuting"
          [_label]="_submitBtnText"
          [command]="EditWordPairDicCommand"
          [disabled]="!isFormValid()"
          (click)="closeDialog()"
        ></ddc-button-s-one>
      </div>
    </div>
  </form>
</div>
